/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import {
    Search,
    TOOLBAR_ITEM_TYPE,
    TOOLBAR_VIEW_TYPE,
    ConfiguredToolbar,
    ConfiguredAdvancedFilter,
    useGlobalLang,
} from '@veeam-vspc/shared/components';
import { EEfsBackupType } from '@veeam-vspc/models/web-controllers';

import type { ConfiguredToolbarProps, ConfiguredAdvancedFilterOptions, AdvancedFilterValue } from '@veeam-vspc/shared/components';
import type { VspcLang } from 'configs/languages';

import snapshotJobTypeIconSrc from 'images/filters/job-types/snapshot.png';
import remoteSnapshotJobTypeIconSrc from 'images/filters/job-types/remote-snapshot.png';
import { useCloudPlatformTypesAdvancedFilter } from 'views/components/filters/CloudPlatformTypesFilters';

export interface FileSharesPublicCloudsFilterToolbarProps extends Omit<ConfiguredToolbarProps, 'items'> {
}

export const FileSharesPublicCloudsFilterToolbar: React.FC<FileSharesPublicCloudsFilterToolbarProps> = (props) => {
    const lang = useGlobalLang<VspcLang>();
    const cloudPlatformTypesAdvancedFilter = useCloudPlatformTypesAdvancedFilter();
    const advancedFilterOptions: ConfiguredAdvancedFilterOptions<AdvancedFilterValue> = {
        header: `${lang.FILTER_PROTECTED_WORKLOADS_BY}:`,
        cols: [
            {
                groups: [
                    {
                        title: lang.TYPE,
                        items: [
                            {
                                iconSrc: snapshotJobTypeIconSrc,
                                label: lang.SNAPSHOT,
                                value: {
                                    id: EEfsBackupType.Backup,
                                    name: 'backupType',
                                },
                            },
                            {
                                iconSrc: remoteSnapshotJobTypeIconSrc,
                                label: lang.REPLICA_SNAPSHOT,
                                value: {
                                    id: EEfsBackupType.BackupCopy,
                                    name: 'backupType',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                groups: [
                    cloudPlatformTypesAdvancedFilter,
                ],
            },
        ],
    };

    return (
        <ConfiguredToolbar
            {...props}
            view={TOOLBAR_VIEW_TYPE.spotted}
            items={[
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='vmName'
                            placeholder={lang.FILE_SHARE}
                        />
                    ),
                },
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <ConfiguredAdvancedFilter
                            label={lang.FILTER}
                            options={advancedFilterOptions}
                        />
                    ),
                },
            ]}
        />
    );
};
